import React, {Component} from 'react';
import {
    Alert,
    Button,
    Form, FormGroup,
    Input, Pagination,
    PaginationItem,
    PaginationLink,
    Table,
    Row,
    Col
} from 'reactstrap';
import {Api} from "../../inc/api";
import * as queryString from "query-string";
import {BarLoader} from "react-spinners";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import RangePicker from "./range_picker";
import Collapse from "./collapse";

export default class Filters extends Component {

    constructor(props) {
        super(props);

        let fils = {
            page: 1,
            word: '',
        };

        if (Array.isArray(this.props.fields)) {
            this.props.fields.forEach(field => {
                if (field.type === "range") {
                    fils[field.nameFrom] = '';
                    fils[field.nameTo] = '';
                } else {
                    fils[field.name] = '';
                }
            });
        }

        let params = queryString.parse(props.location.search);
        Object.keys(params).map((k) => fils[k] = params[k]);

        // Estado inicial
        this.state = {
            loading: false,
            fils: fils,
            items: []
        };
    }

    loadData() {
        this.props.history.push({
            search: '?' + queryString.stringify(this.state.fils)
        });

        this.setState({
            loading: true
        });

        Api.get(this.props.endpoint, this.state.fils, rsp => {
            if (rsp.ok) {
                this.setState({
                    loading: false,
                    items: rsp.items
                });
                this.props.state(rsp);
            } else {
                this.setState({
                    loading: false,
                });
            }

        });
    }

    componentDidMount() {
        this.loadData();
    }

    handleChange = (event) => {
        this.setState({
            fils: {
                ...this.state.fils,
                [event.target.name]: event.target.value
            }
        });
    };

    callbackRangePicker = (rsp, nameFrom, nameTo) => {
        this.setState({
            fils: {
                ...this.state.fils,
                [nameFrom]: rsp.from,
                [nameTo]: rsp.to,
            }
        });
    };

    submit = async (e) => {
        e.preventDefault();
        await this.setState({
            fils: {
                ...this.state.fils,
                page: 1
            }
        });
        this.loadData();
    };

    render() {
        const {props} = this;
        const {fils} = this.state;

        return (
            <div>
                <Form inline className="pb-2 pt-2"
                      hidden={typeof props.no_filters === 'boolean' && props.no_filters}
                      onSubmit={this.submit}>

                    {typeof props.form === 'function' ? props.form() : ''}

                    {!props.notFilterWord && (
                        <FormGroup className="mb-2 mr-2">
                            <Col className="p-0">
                                <div>Búsqueda</div>
                                <Input name="word"
                                       value={fils.word}
                                       onChange={this.handleChange}
                                       placeholder="Buscar..."/>
                            </Col>
                        </FormGroup>
                    )}

                    {Array.isArray(props.fields) ? props.fields.map((o, i) => {
                        switch (o.type) {
                            case 'select':
                                return (
                                    <FormGroup className="mb-2 mr-2" key={i}>
                                        <Col className="p-0">
                                            <div className="mr-sm-2">{o.title}</div>
                                            <Input name={o.name}
                                                   type="select"
                                                   value={fils[o.name]}
                                                   onChange={this.handleChange}
                                                   placeholder="Buscar...">
                                                <option value="">Elegir...</option>
                                                {o.items.map((itm, i2) => <option key={i2} value={itm.id}>
                                                    {itm.name}</option>)}
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                );
                            case 'select2': // select 2 ajax
                                return (
                                    <FormGroup className="mb-2 mr-2" key={i}>
                                        <Col className="p-0">
                                            <div>{o.title}</div>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                isClearable
                                                className="react-select-fils"
                                                classNamePrefix="react-select"
                                                placeholder="Buscar..."
                                                loadOptions={(word, callback) => {
                                                    Api.get(o.endpoint, {word}, rsp => {
                                                        let items = [];
                                                        if (rsp.ok) {
                                                            rsp.items.map((o) => items.push({
                                                                value: o.id,
                                                                label: o.name
                                                            }));
                                                        }
                                                        callback(items);
                                                    });
                                                }}
                                                onChange={(option) => {
                                                    this.setState({
                                                        fils: {
                                                            ...fils,
                                                            [o.name]: option ? option.value : 0
                                                        }
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </FormGroup>
                                );
                            case 'date':
                                return (
                                    <FormGroup key={i} className="mb-2 mr-2">
                                        <Col className="p-0">
                                            <div>{o.title}</div>
                                            <Input name={o.name}
                                                   value={this.state.fils[o.name]}
                                                   type="date"
                                                   onChange={this.handleChange}/>
                                        </Col>
                                    </FormGroup>
                                );
                            case 'range':
                                return (
                                    <FormGroup key={i} className="mb-2 mr-2">
                                        <Col md={12} className="p-0">
                                            <div>{o.title}</div>
                                            <RangePicker
                                                callback={(rsp) => this.callbackRangePicker(rsp, o.nameFrom, o.nameTo)}
                                                fils={true}
                                                name={true}
                                                selected={this.props.rangeSelected}
                                            />
                                        </Col>
                                    </FormGroup>
                                );
                            default:
                                break
                        }
                    }) : ''}

                    <FormGroup className="mb-2 mr-2">
                        <Col className="p-0">
                            <div>&nbsp;</div>
                            <Button color="primary">Aplicar</Button>
                        </Col>
                    </FormGroup>
                </Form>

                <div hidden={!this.state.loading}
                     style={{marginBottom: '-4px', background: 'white', position: 'relative', zIndex: 3}}>
                    <BarLoader width={-1}/>
                </div>
            </div>
        );
    }
}

Filters.propTypes = {
    fields: PropTypes.array,
    collapse: PropTypes.bool,
    no_filters: PropTypes.bool,
    no_pager: PropTypes.bool,
    notFilterWord: PropTypes.bool,
    state: PropTypes.func,
};
